<template>

    <div class="flex h-14 sm:h-24 sm:h-[105px] lg:h-36 rounded-md lg:rounded-2xl bg-white w-full"
        v-if="is_showable">


        <div class="h-full sm:w-[105px] lg:w-[300px] rounded-l-md lg:rounded-l-2xl overflow-hidden bg-cover bg-no-repeat bg-center"
            :class="{
                'w-[57px]': ! is_all_done,
                'w-[110px]': is_all_done
            }"
             :style="`background-image: url('${ current_thumbnail_url }');`">
        </div>


        <div class="flex flex-col justify-center pl-4 sm:pl-8 py-4 lg:pb-5 lg:pt-4 xl:pb-7">

            <p class="hidden lg:inline text-blue text-opacity-60 mb-2 text-sm font-bold">{{ __('Todays exercises') }}</p>

            <h3 class="text-black text-xs mb-2 sm:mb-0 sm:text-2xl font-bold sm:leading-tight">{{ current_exercise_name }}</h3>

            <div class="sm:mt-2 md:mt-3 lg:mt-auto  flex">

                <process-bar
                    v-show="processes.length > 0"
                    :processes="processes"
                    class="md:mr-6 md:w-[231px] w-8/12"
                ></process-bar>

                <p class="hidden xl:inline sm:text-lg font-medium text-black">

                    {{ __(':processed_count of :total_count todays exercises processed', {
                        processed_count,
                        total_count
                    }) }}

                </p>

            </div>

        </div>


        <div class="h-full flex items-center justify-end ml-auto sm:p-2.5 mr-2 sm:mr-0">

            <Link class="bg-blue lg:rounded-2xl rounded-lg w-[55px] h-[45px]  h-12 sm:w-[100px] lg:w-[150px] break-words sm:h-full text-white  font-nexa flex flex-col justify-center items-center hover:bg-dark-blue cursor-pointer"
                :href="current_exercise_url"
                v-if="! is_all_done && ! is_exercise_single">

                <span class="w-full text-[11px] text-sm sm:text-xl lg:text-2xl  p-2 sm:leading-normal md:leading-normal lg:leading-normal flex justify-center items-center text-center">

                    {{ __('Start exercises') }}

                </span>

            </Link>

            <div class="bg-green rounded-md sm:rounded-2xl w-14 sm:w-24 lg:w-40 h-12 sm:h-full text-white text-xs sm:text-2xl font-nexa flex flex-col justify-center items-center hover:bg-dark-blue cursor-pointer"
                @click="handle_click_exercise_done"
                v-else-if="is_exercise_single && ! is_all_done">

                <font-awesome-icon
                    :icon="['fas', 'check']"
                    size="2x"
                    class="text-xs sm:text-xl text-white w-full md:mr-2 md:mt-2 mb-1 sm:mb-4">
                </font-awesome-icon>

                <span class="text-[9px] sm:text-lg md:text-xl leading-tight w-full text-white flex justify-center">

                    {{ __('Done') }}

                </span>

            </div>

        </div>


    </div>

</template>

<script>
import {defineComponent} from "vue";
import ProcessBar from "@/Components/ProcessBar.vue";
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    name: "TodaysExerciseWidget",

    components: {
        ProcessBar,
        Link
    },

    props: {

        target: {
            type: Object,
            default: () => {
                return {
                    id: 1,
                    target_steps: [
                        {
                            id: 1,
                            type: 'step_1',
                            is_completed: true,
                            exercise: {
                                id: 1,
                                slug: 'shoulder-rotations',
                                name: 'Shoulder rotations',
                                thumbnail_url: '/storage/elastic-brestpress-side-to-side-exercise-300x146.jpg'
                            }
                        },
                        {
                            id: 2,
                            type: 'step_2',
                            is_completed: false,
                            exercise: {
                                id: 2,
                                slug: 'elastic-press',
                                name: 'Elastic Press',
                                thumbnail_url: '/storage/elastic-brestpress-side-to-side-exercise-300x146.jpg'
                            }
                        },
                        {
                            id: 3,
                            type: 'step_3',
                            is_completed: false,
                            exercise: {
                                id: 3,
                                slug: 'tip-to-too',
                                name: 'Tip to too',
                                thumbnail_url: '/storage/elastic-brestpress-side-to-side-exercise-300x146.jpg'
                            }
                        }
                    ]
                }
            }
        },

    },

    computed: {

        title() {

            return this.__('Todays exercises');

        },

        target_steps() {

            if (
                ! this.target
                || ! this.target.target_steps
            ) {

                return [];

            }

            return this.target.target_steps;

        },

        current_target_step() {

            return _.find( this.target_steps, { is_completed: false } );

        },

        current_thumbnail_url() {

            let
                locale = this.$page.props.locale
            ;

            if ( ! this.current_target_step ) {

                return `/images/todays-success-thumbs-up-${ locale }.png`;

            }

            return this.current_target_step.exercise.thumbnail_url;

        },

        current_exercise_url() {

            if ( ! this.current_target_step ) {

                return '';

            }

            return route('exercise', {
                exercise: this.current_target_step.exercise.slug
            });

        },

        current_exercise_name() {

            if ( ! this.current_target_step ) {

                return this.__('You have finished todays exercises');

            }

            return this.current_target_step.exercise.name;

        },

        processes() {

            let
                default_processes = [
                    {
                        percent: 30,
                        processed: true,
                        text: 'Shoulder rotations',
                        href: '/exercises/shoulder-rotations'
                    },
                    {
                        percent: 30,
                        processed: false,
                        text: 'Elastic chestpress side-to-side',
                        href: '/exercises/elastic-chestpress-side-to-side'
                    },
                    {
                        percent: 30,
                        processed: false,
                        text: 'Stool - Crab - Only Legs',
                        href: '/exercises/stool-crab-only-legs'
                    }
                ],
                processes = [],
                target_step
            ;


            for ( target_step of this.target_steps ) {

                processes.push({
                    percent: 30,
                    processed: target_step.is_completed,
                    text: target_step.exercise.name,
                    href: route('exercise', target_step.exercise.slug )
                });

            }


            return processes;

        },


        processed_count() {

            return _.filter( this.target_steps, { is_completed: true }).length;

        },


        total_count() {

            return this.target_steps.length;

        },


        is_showable() {                                                   let debug_id = Debug.init_method('is_showable',false);

            let
                current_url = location.href,
                current_path = location.pathname,
                step,
                step_route,
                index
            ;                                                               Debug.log(debug_id,254,{ current_url, current_path });

            if ( current_path.indexOf('/your-exercises') === 0 ) {

                return true;

            }

            for ( step of this.target_steps ) {                                  Debug.log(debug_id,262,step);

                step_route = this.route('exercise', step.exercise.slug );        Debug.log(debug_id,264,step_route);

                index = current_url.indexOf(step_route);                        Debug.log(debug_id,267,index);

                if (
                    index === 0
                ) {                                                             Debug.log(debug_id,268,true);

                    return true;

                }

            }

            return false;

        },


        is_exercise_single() {                                                   let debug_id = Debug.init_method('is_exercise_single',true);

            let
                current_href = location.href,
                exercise_route = this.route('exercise', ''),
                index
            ;                                                                   Debug.log(debug_id,313,{current_href,exercise_route});


            index = current_href.indexOf(exercise_route);                        Debug.log(debug_id,316,index);

            if ( index === 0 ) {                                                Debug.log(debug_id,318,true);

                return true;

            }

            return false;

        },


        is_current_step_open() {                                                   let debug_id = Debug.init_method('is_current_step_open',true);

            let
                current_url = location.href,
                current_step = this.current_target_step,
                url = this.current_exercise_url,
                index
            ;                                                                       Debug.log(debug_id,331,{current_url,current_step,url});

            if ( ! current_step ) {

                return false;

            }


            index = current_url.indexOf(url);                                          Debug.log(debug_id,341,index);

            if ( index === 0 ) {

                return true;

            }

            return false;

        },


        is_all_done() {                                                   let debug_id = Debug.init_method('is_all_done');

            let
                step,
                step_route,
                index
            ;

            for ( step of this.target_steps ) {                                  Debug.log(debug_id,262,step);

                if (
                    ! step.is_completed
                ) {                                                             Debug.log(debug_id,268,true);

                    return false;

                }

            }

            return true;

        },

    },

    methods: {

        handle_click_exercise_done() {                                         let debug_id = Debug.init_method('handle_click_exercise_done',false);

            let
                current_url = location.href,
                step,
                step_route,
                index
            ;

            for ( step of this.target_steps ) {                                  Debug.log(debug_id,262,step);

                step_route = this.route('exercise', step.exercise.slug );        Debug.log(debug_id,264,step_route);

                index = current_url.indexOf(step_route);                        Debug.log(debug_id,267,index);

                if (
                    index === 0
                    && ! step.is_completed
                ) {                                                             Debug.log(debug_id,268,true);

                    this.complete_exercise(step);

                    return;

                }

            }

        },


        complete_exercise(step) {

            this.$inertia.patch(
                route('target_step_user_complete', step.id),
                {},
                {
                    preserveScroll: true,
                    onSuccess: () => {

                        this.$inertia.reload({
                            only: ['target']
                        });

                        if ( this.is_all_done ) {

                            this.$inertia.visit(
                                this.route('your_exercises')
                            );

                        }
                        else {

                            this.$inertia.visit(
                                this.current_exercise_url
                            );

                        }

                    }
                }
            );

        }

    }
});
</script>

<style scoped>

</style>
